import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
    selector: 'scitis-frame-page',
    templateUrl: './frame-page.component.html',
    styleUrls: ['./frame-page.component.scss'],
    standalone: false
})
export class FramePageComponent implements OnChanges {

  safeResourceUrl: SafeResourceUrl = '';

  @Input()
  embeddedContentUrl: string | null = null;

  @Input()
  pageName: string | null = null;

  constructor(
      private sanitizer: DomSanitizer) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.embeddedContentUrl) {
      const url = changes.embeddedContentUrl.currentValue;
      if (url && !url.isNullOrWhitespace()) {
        this.safeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }
    }
  }

}
